import { render, staticRenderFns } from "./KPISetupList.vue?vue&type=template&id=54153c6f"
import script from "./KPISetupList.vue?vue&type=script&lang=js"
export * from "./KPISetupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports